<template>
  <div class="regular-header">
    <navbar />

  <halfBanner>
    <template v-slot:intro-tekst>
      <h1>Newschain</h1>
      <p>Newschain is de krachtigste manier om journalistieke verhalen te vertellen. In één oogopslag overzicht voor je lezers, gedetailleerd inzicht en razensnel publiceren voor de redactie.
        Wij hebben voor Newschain de User Experience uitgewerkt en de daarop volgende User Interface elementen.</p>
      <a v-scroll-to="'#contact'">Read more!</a>
    </template>

    <template v-slot:intro-animation>
        <div class="intro-animation">
          <lottie :options="headerImages[0].defaultOptions"/>    
          <a> {{ headerImages[headerIndex].string }}  </a>
        </div>
    </template>

  </halfBanner>  

<div class="case-page">

<titelPictureBig v-scroll-reveal="{ delay: 550, viewFactor: 0.1}"> 
  <template v-slot:intro-tekst>
    <h2>Iteratief proces</h2>
    <p>Trial and error. Dat is de korte samenvatting van het gehele project. Wij kregen alle vrijheid van Newschain.
      Samen hebben we talloze versies gemaakt en getest. Onze grootste publiek hadden wij bij het AD, maarliefst 200.000 testresultaten. Gelukkiger kan je niet worden als ontwerpbureau. </p>
  </template>
  <template v-slot:case-img>
    <img src="../../assets/cases/newschain/Folded_Paper_Werk_Newschain_image_1.png">
  </template>
</titelPictureBig>

<titelPictureBig v-scroll-reveal="{ delay: 550, viewFactor: 0.1}"> 
  <template v-slot:intro-tekst>
    <h2>Dashboard voor de redactie</h2>
    <p>Na de ontwikkeling van de Newschain blokken was de meest logische stap om een duidelijk interface te ontwerpen waar de redacteuren op de redactie mee aan de slag kunnen gaan. Het aanmaken van een chain moet net zo makkelijk gaan als het lezen van een chain voor de eindgebruiker. Als dit proces niet snel kan gaan lossen wij uiteindelijk ook niks op voor de redactie.</p>
  </template>
  <template v-slot:case-img>
    <img src="../../assets/cases/newschain/Folded_Paper_Werk_Newschain_image_2.png">
  </template>
</titelPictureBig>

<titelPictureBig v-scroll-reveal="{ delay: 550, viewFactor: 0.1}"> 
  <template v-slot:intro-tekst>
    <h2>De definitieve chain</h2>
    <p>Na alle testresultaten te hebben verwerkt is dit de uiteindelijke chain geworden. De chain is overzichtelijk, modern en het belangrijkste de conversie is omhoog gegaan.</p>
  </template>
  <template v-slot:case-img>
    <img src="../../assets/cases/newschain/Folded_Paper_Werk_Newschain_image_3.png">
  </template>
</titelPictureBig>

<titelPictureBig v-scroll-reveal="{ delay: 550, viewFactor: 0.1}"> 
  <template v-slot:intro-tekst>
    <h2>Te gekke resultaten!</h2>
    <p>Omdat Newschain binnen een aantal nationale nieuwsredacties hun pilot uit heeft mogen zetten hebben we een hoop resultaten binnen kunnen halen. Hier hebben wij een reeks illustraties voor ontworpen, waarin feedback van zowel redacteuren en gebruikers terug te zien is. Ook algemene data zoals hoe vaak chains zijn geopend en unieke aantal bezoekers van een chain. Dit maakt alles helemaal compleet.</p>
  </template>
  <template v-slot:case-img>
    <img src="../../assets/cases/newschain/Folded_Paper_Werk_Newschain_image_4.png">
  </template>
</titelPictureBig>

<endCase v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
  <template v-slot:intro-tekst>
    <h2>Newschain samengevat</h2>
    <p>Landelijke pilots en uitzicht op vast gebruik bij het Algemeen Dagblad, hoe gaaf is dat? Wij zijn altijd blij als we meerdere jaren bij een project betrokken kunnen zijn.</p>
  </template>
  <template v-slot:case-img>
    <img src="../../assets/Folded_Paper_Werk_Thanks.jpg">
  </template>
  <template v-slot:outro-tekst>
    <h4>Bekijk ook onze andere toffe cases</h4>
  </template>
</endCase>


 <caseGrid v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
    <div class="row">
      <ul>

        <li>
          <router-link class="router-link" to="/werk/gowallet">
            <div class="column gowallet">
              <img src="../../assets/Folded_Paper_case_thumbnail_GoWallet.jpg">
              <span class="font-size-custom-max-12">Gowallet<br>Branding & product design</span>
            </div>
          </router-link>
          </li>

        <li>
          <router-link class="router-link" to="/werk/avans-hogeschool">
            <div class="column avans">
              <img src="../../assets/Folded_Paper_case_thumbnail_Avans_Hogeschool.jpg">
              <span class="font-size-custom-max-12">Avans Hogeschool<br>Product design</span>
            </div>
          </router-link>
        </li>
    </ul>
  </div>
</caseGrid>

</div>
<footerComponent></footerComponent>

</div>

</template>

<script>
import navbar from '@/components/generalLayout/navbar.vue';

import halfBanner from '@/components/generalLayout/halfBanner.vue';
import scissorsButton from '@/components/generalLayout/scissorsButton.vue';
import titel from '@/components/generalLayout/werk/titel.vue';
import titelPictureBig from '@/components/generalLayout/werk/titelPictureBig.vue';
import caseGrid from '@/components/generalLayout/caseGrid.vue';
import endCase from '@/components/generalLayout/werk/endCase.vue';
import footerComponent from '@/components/specificLayout/footerComponent.vue';


import Lottie from '../../lottie.vue';
import * as animationNewschain from '@/assets/cases/newschain/headeranimatie/newschain.json';


export default {
    data () {
    return {
      headerImages: [
	      { defaultOptions: {animationData: animationNewschain.default}, string:'UX design / UI design / Illustratie', },
      ],
    }
  },
  components:{
    navbar,
    halfBanner,
    titel,
    titelPictureBig,
    caseGrid,
    scissorsButton,
    endCase,
    footerComponent,
    'lottie': Lottie,
  },

  methods:{
    randomNumber(maxValue){
      return Math.floor(Math.random() * Math.floor(maxValue));
    }
  },
  computed:{
    headerIndex(){
      return this.randomNumber(this.headerImages.length);
    }
  },
}



</script>

<style lang="scss">

.home-bg-color{
  background: rgba(173, 227, 245, 0.15) !important;
  background-repeat: no-repeat;
  background-size: cover;
}

.fold-container .first-content .intro-tekst{
  animation-delay: 1.4s;
}

.regular-header .fold-container .home-bg-color{
  animation-delay: .6s;
}

.regular-header .fold-container .case-hightlight-img .intro-animation{
  animation-delay: 1s;
}

@media screen and (max-width: 720px) {
  .content-grid-two-rows{
    .firstenergy, .loud, .newschain, .tca{
      float: none;
    }
  }
}

@media screen and (max-width: 640px) {
  body .case .img-box img, .odd-even-grid .text-box img{
    max-width: 90% !important;
  }
  .home-bg-color{
    width: 100% !important;
    max-width: 100% !important;
    left:12px;
    border-right: 24px solid $white !important;
  }
}

</style>
